import '../bootstrap/global-error-handler';
import agent from '../agent.js';
import __ from '../translations/translate';
import { utils } from '../mixins';
import Swal from 'sweetalert2';
import FullPageLoader from '@components/FullPageLoader.vue';

import { mountRootOptions } from '../bootstrap/vue-app';

const doublefa_view = mountRootOptions({
    el: '#login-card',
    mixins: [utils],
    components: {
        FullPageLoader,
    },
    data: {
        user: {
            id: null,
            email: '',
            rememberMe: false,
        },
        emailTouched: false,
        isFakeUser: false,
        pin: '',
        inputErrors: {
            error: '',
        },
        recaptchaResponse: '',
        urlParams: '',
        urlHash: '',
        isLoggingIn: false,
        authSent: false,
        isAuthenticating: false,
        isBlockIp: false,
        isIpBlocked: false,
        seconds: 30,
        timerId: null,
    },
    mounted() {
        let self = this;
        self.urlHash = window.location.hash;
        self.urlParams = new URLSearchParams(window.location.search);
        const uid = self.urlParams.get('uid');
        const token = self.urlParams.get('token');
        const scope = self.urlParams.get('scope');
        const email = self.urlParams.get('email');
        const rememberMe = self.urlParams.get('remember_me');
        const blockToken = self.urlParams.get('block_token');

        $(document).on('click', '.button-login', function () {
            self.isFakeUser = false;
            self.getRecaptchaCallback().then(() => {
                self.authenticateUser();
                self.startCountdown();
            });
        });
        $(document).on('click', '.reset-code', function (e) {
            e.preventDefault();
            let data = {
                id: self.user.id,
            };
            agent.User.resetAuth(data)
                .then(function (result) {
                    self.popUpEmailSent(true);
                })
                .catch(function (error) {
                    self.popUpEmailSent(false);
                });
        });
        if (uid && token && scope && email) {
            if (blockToken) {
                this.isBlockIp = true;
                if (scope === 'backend') {
                    setTimeout(() => {
                        let data = {
                            uid: uid,
                            token: token,
                            scope: scope,
                            blockToken: blockToken,
                        };
                        agent.User.blockIP(data)
                            .then(function (result) {
                                self.isIpBlocked = true;
                                self.isBlockIp = false;
                                setTimeout(() => {
                                    window.close();
                                }, 10000);
                            })
                            .catch(function (error) {
                                self.inputErrors.error = self.getSafeErrorMessage(error);
                                self.isBlockIp = false;
                            });
                    });
                }
            } else {
                this.isAuthenticating = true;
                if (scope === 'backend') {
                    let data = {
                        email: email,
                        recaptchaResponse: '',
                        next: this.urlParams.get('next'),
                        urlHash: this.urlHash,
                        uid: uid,
                        token: token,
                        scope: scope,
                        rememberMe: rememberMe === 'True',
                    };
                    agent.User.userLogin(data)
                        .then(function (result) {
                            window.location.replace(result.data.next ? result.data.next : '/');
                        })
                        .catch(function (error) {
                            self.inputErrors.error = self.getSafeErrorMessage(error);
                            self.isAuthenticating = false;
                        });
                }
            }
        }
    },
    created() {},
    methods: {
        resend() {
            let self = this;
            if (self.isFakeUser) {
                self.startCountdown();
            } else {
                self.getRecaptchaCallback().then(() => {
                    self.authenticateUser();
                    self.startCountdown();
                });
            }
        },
        startCountdown() {
            clearInterval(this.timerId);
            this.seconds = 30;
            this.timerId = setInterval(() => {
                if (this.seconds > 0) {
                    this.seconds--;
                } else {
                    clearInterval(this.timerId);
                }
            }, 1000);
        },
        handleResend() {
            this.$emit('resend');
            this.startCountdown();
        },
        markEmailTouched() {
            this.emailTouched = true;
        },
        isLoginValid() {
            return !!this.user.email && this.isValidEmail(this.user.email);
        },
        authenticateUser() {
            let self = this;
            let data = {
                email: this.user.email,
                recaptchaResponse: this.recaptchaResponse,
                next: this.urlParams.get('next'),
                urlHash: this.urlHash,
                rememberMe: this.user.rememberMe,
            };
            agent.User.userAuth(data)
                .then(function (result) {
                    if (result.data && result.data.user) {
                        self.user = { ...self.user, ...result.data.user };
                    }
                    self.inputErrors.error = '';
                    self.authSent = true;
                })
                .catch(function (error) {
                    if (error.response && error.response?.data) {
                        if (error.response?.status === 403 && error.response?.data?.error === 'Incorrect credentials') {
                            self.authSent = true;
                            self.isFakeUser = true;
                        } else {
                            self.inputErrors.error = self.getSafeErrorMessage(error);
                        }
                    } else {
                        self.inputErrors.error = self.getSafeErrorMessage(error);
                    }
                })
                .finally(function () {
                    self.isLoggingIn = false;
                });
        },
        popUpEmailSent(result) {
            Swal.fire({
                icon: result ? 'success' : 'warning',
                title: result ? __('Email sent successfully') : __('Error sending email with confirmation'),
            });
        },
        getSafeErrorMessage(error) {
            const fallback = __('Something went wrong');
            if (!error || !error.response || error.response?.status >= 500) {
                return fallback;
            }
            const data = error.response?.data || {};
            return data.message || data.error || fallback;
        },
        getRecaptchaCallback: function (response) {
            if (disable_captcha) {
                this.recaptchaResponse = 'debug-recaptcha-response';
                return Promise.resolve();
            } else {
                return grecaptcha
                    .execute('6LepM5coAAAAAP0CuBKA5E_qy7p62lUVvcWw2KYA', { action: 'login' })
                    .then(token => {
                        this.recaptchaResponse = token;
                    });
            }
        },
        stepBack() {
            this.authSent = false;
        },
        onEnter() {
            if (this.isLoginValid()) {
                this.getRecaptchaCallback().then(() => {
                    this.authenticateUser();
                });
            }
        },
    },
    computed: {
        emailState() {
            if (!this.emailTouched) {
                return null;
            }
            return this.isValidEmail(this.user.email);
        },
        showEmailRequired() {
            return this.emailTouched && !this.user.email;
        },
        showEmailInvalid() {
            return this.emailTouched && !!this.user.email && !this.isValidEmail(this.user.email);
        },
        isLoginDisabled() {
            return !this.isLoginValid();
        },
    },
    beforeUnmount() {
        clearInterval(this.timerId);
    },
});

export default doublefa_view;
